import React from "react";
import "./HeroSection.css";

import spiritualBackground from "../../../assets/hero-seller.png";

const HeroSection = () => {
  const sectionStyle = {
    backgroundImage: `url(${spiritualBackground})`,
  };

  return (
    <section className="how-it-works-section" style={sectionStyle}>
      <div className="hiw-overlay"></div>

      <div className="hiw-content-wrapper">
        <div className="hiw-content">
          <h1 className="hiw-title">
            <span className="title-brand-name">Vanidya</span> makes mindful shopping simple
          </h1>
          <p className="hiw-subtitle">
              Discover a simpler way to shop for Satvik foods, organic groceries, pooja essentials and spiritual books.<br /><br />
              From browsing to doorstep delivery, every step is designed to give you clarity, confidence and products you trust.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
